import './form.scss';
import { throws } from 'assert';

const FormComponent = {
  elements: null,


  init() {
    this.bindForms();
    window.addEventListener('rebindForms', this.bindForms.bind(this));
  },

  // =======================================
  // Inputs
  // =======================================
  bindInputFields(form) {
    let inputs = form.querySelectorAll('.form-input__field-set');

    inputs.forEach((input) => {
      this.inputs.setupInput(input);
    });
  },

  inputs: {
    references: {},

    setupInput(input) {
      let reference = this.getReference(input);

      this.references[reference.fieldName] = reference;



      input.addEventListener('click', (ev) => {
        input.classList.remove('invalid');
        input.classList.remove('form-input__field-set--inactive');

        if (reference.inputField) {
          reference.inputField.placeholder = '';
          reference.inputField.focus();
        }

        if (reference.textField) {
          reference.textField.placeholder = '';
          reference.textField.focus();
        }

        ev.stopPropagation();
      });

      if (reference.inputField) {
        if (reference.inputField.value !== '') {
          input.classList.remove('invalid');
          input.classList.remove('form-input__field-set--inactive');
        }
        reference.inputField.addEventListener('blur', () => {
          if (reference.inputField.value === '') {
            reference.inputField.placeholder = reference.inputPlaceholderText;
            input.classList.add('form-input__field-set--inactive');
          }
        });
      }

      if (reference.textField) {
        if (reference.textField.value !== '') {
          input.classList.remove('invalid');
          input.classList.remove('form-input__field-set--inactive');
        }
        reference.textField.addEventListener('blur', () => {
          if (reference.textField.value === '') {
            reference.textField.placeholder = reference.textPlaceholderText;
            input.classList.add('form-input__field-set--inactive');
          }
        });
      }
    },

    getReference(input) {
      return {
        fieldName: input.querySelector('.form__input') ? input.querySelector('.form__input').name : null,
        inputPlaceholderText: input.querySelector('.form__input') ? input.querySelector('.form__input').placeholder : null,
        inputField: input.querySelector('.form__input') ? input.querySelector('.form__input') : null,
        textField: input.querySelector('.form__textarea') ? input.querySelector('.form__textarea') : null,
        textPlaceholderText: input.querySelector('.form__textarea') ? input.querySelector('.form__textarea').placeholder : null,
        inputLabel: input.querySelector('.form__label') ? input.querySelector('.form__label') : null
      };
    }
  },

  bindForms() {
    this.elements = document.querySelectorAll('form');
    this.elements.forEach((form) => {
      this.bindCheckboxes(form);
      this.bindInputFields(form);
      this.bindSelectBoxes(form);
    });
  },

  // =======================================
  // Select Boxes
  // =======================================
  bindSelectBoxes(form) {
    let selectBoxes = form.querySelectorAll('.form-input__select-field');

    selectBoxes.forEach((selectBox) => {
      this.selectBoxes.setupSelectBox(selectBox);
    });
  },

  selectBoxes: {
    references: {},

    setupSelectBox(selectBox) {
      let reference = this.getReference(selectBox);

      this.references[reference.fieldName] = reference;

      reference.selectedOption.addEventListener('click', () => {
        selectBox.classList.remove('invalid');
        this.toggleState(reference);
      });

      reference.otherOptions.forEach((opt) => {
        opt.addEventListener('click', () => {
          this.selectOption(opt, reference);
        });
      });
    },

    toggleState(reference) {
      reference.primary.classList.toggle('form-input__select-field--active');
      reference.primary.classList.toggle('form-input__select-field--inactive');
    },

    selectOption(opt, reference) {
      let optionText = opt.textContent;
      let optionValue = opt.querySelector('input[type=hidden]').value;

      reference.primary.classList.add('option-is-selected');
      reference.hiddenField.value = optionValue;
      reference.selectedOption.textContent = optionText;
      console.log(optionValue);

      this.toggleState(reference);
    },

    getReference(selectBox) {
      return {
        primary: selectBox,
        fieldName: selectBox.getAttribute('data-field-name'),
        hiddenField: selectBox.querySelectorAll('.hidden__input')[0],
        selectedOption: selectBox.querySelectorAll('.selected-option')[0],
        otherOptions: selectBox.querySelectorAll('.other-options li')
      };
    }
  },

  // =======================================
  // Checkboxes
  // =======================================
  bindCheckboxes(form) {
    let checkboxes = form.querySelectorAll('.checkbox-input');

    checkboxes.forEach((checkbox) => {
      this.checkboxes.setupCheckbox(checkbox);
    });
  },

  checkboxes: {
    references: {},

    setupCheckbox(checkbox) {
      let reference = this.getReference(checkbox);

      // Assign the reference
      this.references[reference.fieldName] = reference;

      if(reference.hiddenField.value == "true") {
        reference.inputBox.classList.add('checkbox-input__box--checked');
      }

      // Setup event bindings
      checkbox.addEventListener('click', () => {
        this.toggleState(reference);
      });
    },

    toggleState(ref) {
      // hiddenField.value is a string, let's make it a boolean
      let val = ref.hiddenField.value == "true";
      val = !val;

      this.updateReference(val, ref);
    },

    getReference(checkbox) {
      return {
        fieldName: checkbox.querySelector('input[type=hidden]').name,
        fieldSet: checkbox.querySelector('.checkbox-input__checkbox'),
        hiddenField: checkbox.querySelector('input[type=hidden]'),
        inputBox: checkbox.querySelector('.checkbox-input__box'),
        state: checkbox.querySelector('input[type=hidden]').value
      };
    },

    updateReference(val, ref) {
      ref.hiddenField.value = val;
      ref.state = val;
      ref.inputBox.classList.toggle('checkbox-input__box--checked');
    }
  }
};

export default FormComponent;
